import { AfterViewInit, ChangeDetectorRef, Component, ComponentRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { DialogConfirmComponent } from '../../dialog-confirm/dialog-confirm.component';
import { MatDialog } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DropDownModel } from '../../../../domain/model/common/dropDownModel';
import { MatTableDataSource } from '@angular/material/table';
import { atLeastOneRequiredValidator } from '../../../../shared/utils/atLeastOneRequiredValidator';
import { PropertyOwner } from '../../../../domain/model/enrollment/propertyOwner';
import { OwnerEnrollment } from '../../../../domain/model/enrollment/ownerEnrollment';
import { PropertyOwnerEnrollment } from '../../../../domain/model/enrollment/propertyOwnerEnrollmentDTO';
import { ManagementCompany } from '../../../../domain/model/enrollment/managementCompanies';
import { Dialog } from '@angular/cdk/dialog';
import { ManagementCompanyAddComponent } from '../../management-company-add/management-company-add.component';
import { EnrollmentRentalProperty } from '../../../../domain/model/enrollment/enrollmentRentalProperty';
import { EnrollmentRentalPropertyLicense } from '../../../../domain/model/enrollment/enrollmentRentalPropertyLicense';
import { EnrollmentTaxRepresentative } from '../../../../domain/model/enrollment/enrollmentTaxRepresentative';
import { OwnerCompanyAddComponent } from '../../owner-company-add/owner-company-add.component';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { NotificationComponent } from '../../../../shared/notification/notification.component';
import { ComponentPortal } from '@angular/cdk/portal';
import { NotificationType } from '../../../../domain/model/enums/notificationType';
import { RentalPropertyComponent } from '../shared/rental-property/rental-property.component';
import { RentalPropertyLicenseComponent } from '../shared/rental-property-license/rental-property-license.component';
import { RentalPropertyReportingFormComponent } from '../shared/rental-property-reporting-form/rental-property-reporting-form.component';
import { Observable } from 'rxjs';
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CanComponentDeactivate } from '../../../../security/unsaved-changes.guard';
import { CommonServices } from '../../../../domain/service/commonService';
import { EnrollmentService } from '../../../../domain/service/enrollmentService';
import { GooglePlacesService } from '../../../../domain/service/GooglePlaceService';
import { Router } from '@angular/router';


const OWNER_DATA: PropertyOwner[] = [
];
const COMPANY_DATA: ManagementCompany[] = [];

@Component({
  selector: "app-add-individual-owner",
  templateUrl: "./add-individual-owner.component.html",
  styleUrl: "./add-individual-owner.component.css",
})
export class AddIndividualOwnerComponent implements OnInit, AfterViewInit, CanComponentDeactivate {
  dialog = inject(Dialog);
  @ViewChild("rentalPropertyComponent") rentalPropertyComponent: RentalPropertyComponent | undefined;
  @ViewChild("rentalPropertyLicenseComponent") rentalPropertyLicenseComponent:
    | RentalPropertyLicenseComponent
    | undefined;
  @ViewChild("rentalPropertyReportingFormComponent") rentalPropertyReportingFormComponent:
    | RentalPropertyReportingFormComponent
    | undefined;
  private overlayRef!: OverlayRef;
  currentCompany: ManagementCompany | undefined;
  isManager = false;
  isOwner = false;
  showTaxRepresentativeForm: boolean = false;
  showCityLocalRequirements = false;
  stepCompleted: boolean = false;
  addressType: string = "1";
  checkbox: any;
  displayedColumns: string[] = ["firstName", "lastName", "email", "phoneNumber", "action"];
  managementcompaniesColumns: string[] = [
    "name",
    "streetAddress",
    "aptUnitSuite",
    "city",
    "state",
    "zipCode",
    "action",
  ];
  dataSource = new MatTableDataSource(OWNER_DATA);
  companyDataSource = new MatTableDataSource(COMPANY_DATA);
  managementcompanies: ManagementCompany[] = [];
  propertyOwners: PropertyOwner[] = [];
  editCache: { [key: string]: any } = {};
  suggestions: any[] = [];
  searchControl = new FormControl();
  options: string[] = ["One", "Two", "Three"];
  filteredOptions!: Observable<string[]>;
  myControl = new FormControl("");
  streetAddress: string = "";
  constructor(
    private googlePlacesService: GooglePlacesService,
    private cd: ChangeDetectorRef,
    private overlay: Overlay,
    public dialogRef: MatDialog,
    private commonServices: CommonServices,
    private _formBuilder: FormBuilder,
    private enrollment: EnrollmentService,
    private router: Router
  ) {
    this.searchControl.valueChanges.subscribe((value) => {
      if (value) {
        this.googlePlacesService.getPlaces(value).then((predictions: any) => {
          this.suggestions = predictions;
          console.log(predictions);
        });
      } else {
        this.suggestions = [];
      }
    });
    this.ownerForm.get("ownerStreetAddress")?.valueChanges.subscribe((value) => {
      if (value) {
        this.googlePlacesService.getPlaces(value).then((predictions: any) => {
          this.suggestions = predictions;
          console.log(this.suggestions);
        });
      } else {
        this.suggestions = [];
      }
    });
  }
  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }
  showNotification(message: string, title: string, notificationType: NotificationType): void {
    // Create a Portal instance of our `NotificationComponent`
    const notificationPortal = new ComponentPortal(NotificationComponent);
    // Attach our `NotificationComponent` to the Overlay Portal
    const notificationRef: ComponentRef<NotificationComponent> = this.overlayRef.attach(notificationPortal);
    // Now we can access the component instance
    // and we can pass input for the `message` prop we created.
    notificationRef.instance.message = message;
    notificationRef.instance.title = title;
    notificationRef.instance.type = notificationType;
    notificationRef.instance.overlayRef = this.overlayRef;
    notificationRef.instance.getColor();

    // Set a timeout to detach our component from the overlay
    // after 3000 milliseconds
    setTimeout(() => {
      this.overlayRef.detach();
    }, 10000);
  }
  ngOnDestroy(): void {
    this.overlayRef.detach();
  }
  ngOnInit(): void {
    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy: this.overlay.position().global().top("20px").right("30px"),
    });
    this.commonServices.getAllCountry().subscribe((data) => {
      this.country = data.sort((a, b) => a.name.localeCompare(b.name));
    });

    this.commonServices.getAllState(233).subscribe((data) => {
      this.states = data.sort((a, b) => a.name.localeCompare(b.name));
    });

    this.wireZipAutofill(this.ownerForm, true);
    this.wireZipAutofill(this.propertyBasicInfo);
  }

  /**
   * When a 5-digit zip is entered, look up city/state and fill them in.
   * Uses { emitEvent: false } so filling fields doesn't re-trigger lookups.
   */
  /**
   * @param stateAsString the form's State <mat-option> values are `id.toString()`; a numeric id
   *   can't be matched by mat-select and the dropdown goes blank (Todd: "state set then blanked"
   *   after address autocomplete — selectPlace set the state, then this lookup overwrote it).
   */
  private wireZipAutofill(form: FormGroup, stateAsString = false): void {
    form
      .get("zipCode")
      ?.valueChanges.pipe(debounceTime(400), distinctUntilChanged())
      .subscribe(async (zip: string | null) => {
        const loc = await this.googlePlacesService.getLocationByZip(zip ?? "");
        if (!loc) {
          return;
        }
        if (loc.city) {
          form.get("city")?.setValue(loc.city, { emitEvent: false });
        }
        if (loc.stateCode) {
          const stateId = this.states.find((e) => e.iso2 == loc.stateCode)?.id;
          if (stateId) {
            form.get("state")?.setValue(stateAsString ? stateId.toString() : stateId, { emitEvent: false });
          }
        }
      });
  }

  state!: number;
  states: DropDownModel[] = [];
  country: DropDownModel[] = [];
  ownerForm = new FormGroup({
    firstName: new FormControl("", [Validators.required, Validators.maxLength(200)]),
    lastName: new FormControl("", [Validators.required, Validators.maxLength(200)]),
    email: new FormControl("", [Validators.required, Validators.maxLength(320), Validators.email]),
    phoneNumber: new FormControl("", [
      Validators.required,
      Validators.maxLength(100),
      Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/),
    ]),
    note: new FormControl(""),
    ownerStreetAddress: new FormControl("", Validators.required),
    aptUnitSuite: new FormControl(""),
    city: new FormControl("", Validators.required),
    state: new FormControl("", [Validators.required, Validators.min(0)]),
    zipCode: new FormControl("", [
      Validators.required,
      Validators.maxLength(12),
      Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/),
    ]),
    addressName: new FormControl(""),
    addressOrPoBox: new FormControl(""),
    cityStateProvince: new FormControl(""),
    country: new FormControl(""),
  });
  rentalPropertyReporting = new FormGroup({
    taxRepresentativeFirstName: new FormControl(),
    taxRepresentativeLastName: new FormControl(),
    taxRepresentativeEmail: new FormControl(),
    taxRepresentativePhoneNumber: new FormControl(),
    taxRepresentativeStreetAddress: new FormControl(),
    taxRepresentativeAptUnitSuite: new FormControl(),
    taxRepresentativeCity: new FormControl(),
    taxRepresentativeState: new FormControl(),
    taxRepresentativeZipCode: new FormControl(),
    sendToOwner: new FormControl(),
    sendToReportingRep: new FormControl(),
    isUsingTaxRepresentative: new FormControl(null),
  });
  propertyBasicInfo = new FormGroup(
    {
      propertyStreetAddress: new FormControl("", [Validators.required]),
      aptUnitSuite: new FormControl(""),
      city: new FormControl("", [Validators.required]),
      state: new FormControl(1436, [Validators.required]),
      zipCode: new FormControl("", [
        Validators.required,
        Validators.maxLength(400),
        Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/),
      ]),
      startedRenting: new FormControl(null, [Validators.required]),
      filingFrequency: new FormControl("", [Validators.required]),
      businessName: new FormControl(""),
      webUrl: new FormControl("", [
        Validators.pattern(/^(https?:\/\/|www\.)[a-zA-Z0-9\-\.]+(?:\.[a-zA-Z]{2,})(?:\/[a-zA-Z0-9\-]+)*\/?$/),
      ]),
      usePlatformToRent: new FormControl(false),
      platFormLink: new FormControl("", [
        Validators.pattern(/^(https?:\/\/|www\.)[a-zA-Z0-9\-\.]+(?:\.[a-zA-Z]{2,})(?:\/[a-zA-Z0-9\-]+)*\/?$/),
      ]),
      rentalPropertyBusiness: new FormControl(""),
    },
    { validators: atLeastOneRequiredValidator(["usePlatformToRent", "platFormLink"]) }
  );

  rentalPropertyLicense = new FormGroup(
    {
      departmentOfBusiness: new FormControl("", [Validators.pattern(/^[a-zA-Z1-9][a-zA-Z0-9]*$/)]),
      taxCertificateNumber: new FormControl(""),
      stateCertificateHasBeenApplied: new FormControl(null),
      reasonWhy: new FormControl(""),
      certificateOfRegistration: new FormControl(""),
      localBusinessTaxReceipt: new FormControl(""),
      cityOfRegistration: new FormControl(""),
    },
    { validators: atLeastOneRequiredValidator(["reasonWhy", "stateCertificateHasBeenApplied", "taxCertificateNumber"]) }
  );

  agreements = new FormGroup({
    confirmRead: new FormControl(null, [Validators.requiredTrue]),
    confirmAllInformation: new FormControl(null, [Validators.requiredTrue]),
    printedName: new FormControl("", [Validators.required]),
  });
  goBack(stepper: MatStepper) {
    stepper.previous();
  }
  goForward(stepper: MatStepper) {
    if (stepper.selectedIndex == 0) {
      this.showNotification(
        "During the registration process you will be required to add at least one property to complete your account setup. Once your account is verified, you will have the flexibility to add as many properties as you wish within our platform.",
        "Important",
        NotificationType.InfoStepper
      );
    }
    stepper.next();
  }
  showManager(event: any) {}
  isEdit: boolean = false;
  selectedPropertyOwner: Partial<PropertyOwner> = {};
  propertyOwnerForm!: FormGroup;
  newPropertyOwnerForm!: FormGroup;
  newGuid(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  addNewPropertyOwner() {
    // Validar que no se exceda el límite de 3 propietarios adicionales
    if (OWNER_DATA.length >= 3) {
      this.showNotification(
        "Maximum of 3 additional owners allowed",
        "Limit Reached",
        NotificationType.Warning
      );
      return;
    }

    let owner: PropertyOwner = {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      internalId: this.newGuid(),
      streetAddress: "",
      aptUnitSuite: "",
      city: "",
      zipCode: "",
      internationalAddressName: "",
      internationalPoboxNumber: "",
      internationalCityStateProvince: "",
      stateId: 0,
      countryId: 0,
      addressType: 0,
      id: 0,
    };
    const dialogRef = this.dialog.open<PropertyOwner>(OwnerCompanyAddComponent, {
      width: "500px",
      maxHeight: "90vh",
      disableClose: true,
      data: { owner: owner, states: this.states, country: this.country },
    });

    dialogRef.closed.subscribe((result) => {
      console.log("The dialog was closed");

      if (result) {
        OWNER_DATA.push(result);
        this.dataSource = new MatTableDataSource(OWNER_DATA);
      }
    });
  }
  editOwner(owner: PropertyOwner) {
    const dialogRef = this.dialog.open<PropertyOwner>(OwnerCompanyAddComponent, {
      width: "500px",
      maxHeight: "90vh",
      disableClose: true,
      data: { owner: owner, states: this.states, country: this.country },
    });

    dialogRef.closed.subscribe((result) => {
      console.log("The dialog was closed");

      if (result) {
        let index = OWNER_DATA.findIndex((e) => e.internalId == result.internalId);
        OWNER_DATA[index] = result;
        this.dataSource = new MatTableDataSource(OWNER_DATA);
      }
    });
  }

  removeOwner(index: number) {
    const dialogRef = this.dialogRef.open(DialogConfirmComponent, {
      width: '500px',
      height: '210px',
      data: {
        title: 'Delete Owner',
        message: 'Are you sure you want to delete this owner?',
        confirmButtonText: 'DELETE',
        cancelButtonText: 'CANCEL'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        OWNER_DATA.splice(index, 1);
        this.dataSource = new MatTableDataSource(OWNER_DATA);
      }
    });
  }
  addCompany() {
    let company: ManagementCompany = {
      companyName: "",
      streetAddress: "",
      aptUnitSuite: "",
      city: "",
      state: 0,
      zipCode: "",
      internalId: this.newGuid(),
      stateName: "",
      id: 0,
      accountId: 0,
      rentalPropertyId: 0,
    };

    const dialogRef = this.dialog.open<ManagementCompany>(ManagementCompanyAddComponent, {
      height: "510px",
      disableClose: true,
      data: { company },
    });

    dialogRef.closed.subscribe((result) => {
      console.log("The dialog was closed");
      this.currentCompany = result;
      console.log(result);
      if (result) {
        COMPANY_DATA.push(result);
        this.companyDataSource = new MatTableDataSource(COMPANY_DATA);
      }
    });
  }
  editCompany(company: ManagementCompany) {
    const dialogRef = this.dialog.open<ManagementCompany>(ManagementCompanyAddComponent, {
      width: "500px",
      height: "510px",
      disableClose: true,
      data: { company },
    });

    dialogRef.closed.subscribe((result) => {
      console.log("The dialog was closed");
      this.currentCompany = result;
      if (result) {
        let index = COMPANY_DATA.findIndex((e) => e.internalId == result.internalId);
        COMPANY_DATA[index] = result;
        this.companyDataSource = new MatTableDataSource(COMPANY_DATA);
      }
    });
  }
  removeCompany(index: number) {
    COMPANY_DATA.splice(index, 1);

    this.companyDataSource = new MatTableDataSource(COMPANY_DATA);
  }

  radioChangeAddress(event: any) {
    this.addressType = event.value;
    if (event.value == "1") {
      this.ownerForm.get("addressName")?.clearValidators();
      this.ownerForm.get("addressName")?.updateValueAndValidity();

      this.ownerForm.get("addressOrPoBox")?.clearValidators();
      this.ownerForm.get("addressOrPoBox")?.updateValueAndValidity();

      this.ownerForm.get("cityStateProvince")?.clearValidators();
      this.ownerForm.get("cityStateProvince")?.updateValueAndValidity();

      this.ownerForm.get("country")?.clearValidators();
      this.ownerForm.get("country")?.updateValueAndValidity();

      this.ownerForm.get("ownerStreetAddress")?.addValidators(Validators.required);
      this.ownerForm.get("ownerStreetAddress")?.updateValueAndValidity();

      this.ownerForm.get("city")?.addValidators(Validators.required);
      this.ownerForm.get("city")?.updateValueAndValidity();

      this.ownerForm.get("state")?.addValidators(Validators.required);
      this.ownerForm.get("state")?.updateValueAndValidity();

      this.ownerForm.get("zipCode")?.addValidators(Validators.required);
      this.ownerForm.get("zipCode")?.addValidators(Validators.maxLength(12));
      this.ownerForm.get("zipCode")?.addValidators(Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/));
      this.ownerForm.get("zipCode")?.updateValueAndValidity();
    }
    if (event.value == "2") {
      this.ownerForm.get("addressName")?.addValidators(Validators.required);
      this.ownerForm.get("addressName")?.updateValueAndValidity();

      this.ownerForm.get("addressOrPoBox")?.addValidators(Validators.required);
      this.ownerForm.get("addressOrPoBox")?.updateValueAndValidity();

      this.ownerForm.get("cityStateProvince")?.addValidators(Validators.required);
      this.ownerForm.get("cityStateProvince")?.updateValueAndValidity();

      this.ownerForm.get("country")?.addValidators(Validators.required);
      this.ownerForm.get("country")?.updateValueAndValidity();

      this.ownerForm.get("ownerStreetAddress")?.clearValidators();
      this.ownerForm.get("ownerStreetAddress")?.updateValueAndValidity();

      this.ownerForm.get("aptUnitSuite")?.clearValidators();
      this.ownerForm.get("aptUnitSuite")?.updateValueAndValidity();

      this.ownerForm.get("city")?.clearValidators();
      this.ownerForm.get("city")?.updateValueAndValidity();

      this.ownerForm.get("state")?.clearValidators();
      this.ownerForm.get("state")?.updateValueAndValidity();

      this.ownerForm.get("zipCode")?.clearValidators();
      this.ownerForm.get("zipCode")?.updateValueAndValidity();
    }
  }
  async selectPlace(place: any) {
    this.suggestions = [];
    const details = await this.googlePlacesService.getPlaceDetails(place.place_id);
    let selectedZipCode = this.googlePlacesService.extractLocationDetails(details);
    if (selectedZipCode.zip) {
      // The place already gave us city/state: don't fire the zip lookup on top of it.
      this.ownerForm.get("zipCode")?.setValue(selectedZipCode.zip, { emitEvent: false });
    }

    if (selectedZipCode.city) {
      this.ownerForm.get("city")?.setValue(selectedZipCode.city);
    }

    if (selectedZipCode.stateCode) {
      let stateId = this.states.find((e) => e.iso2 == selectedZipCode.stateCode)?.id ?? 0;
      console.log(stateId.toString());
      this.ownerForm.get("state")?.setValue(stateId.toString());
    }

    if (selectedZipCode.address) {
      this.ownerForm.get("ownerStreetAddress")?.setValue(selectedZipCode.address);
      this.ownerForm.get("ownerStreetAddress")?.updateValueAndValidity();
      this.ownerForm.get("ownerStreetAddress")?.markAsUntouched();
    }
  }

  save() {
    let _enrollmentRentalProperty: EnrollmentRentalProperty = {
      rentalPropertyStreetAddress: this.propertyBasicInfo?.get("propertyStreetAddress")?.value ?? "",
      aptUnitSute: this.propertyBasicInfo?.get("aptUnitSuite")?.value ?? "",
      city: this.propertyBasicInfo?.get("city")?.value ?? "",
      state: this.propertyBasicInfo.get("state")?.value ?? 0,
      zipCode: this.propertyBasicInfo?.get("zipCode")?.value ?? "",
      startedRenting: this.propertyBasicInfo?.get("startedRenting")?.value ?? "",
      filingFrecuency: this.propertyBasicInfo?.get("filingFrequency")?.value ?? "",
      businessName: undefined,
      webUrl: undefined,
      useDigitalPlatform: this.propertyBasicInfo?.get("usePlatformToRent")?.value ?? false,
      digitalPlatform: this.propertyBasicInfo?.get("platFormLink")?.value ?? "",
      frequency: this.propertyBasicInfo?.get("filingFrequency")?.value ?? "",
      isOwner: this.isOwner,
      isPropertyManagementCompany: this.isManager,
      // Without a tax representative the checkboxes are hidden: correspondence goes to the owner (QA 2026-10-05).
      correspondenceToOwner: (this.rentalPropertyReporting.get("isUsingTaxRepresentative")?.value as boolean | null) !== true
        || (this.rentalPropertyReporting.get("sendToOwner")?.value ?? false),
      correspondenceToReportingRepresentative: this.rentalPropertyReporting.get("sendToReportingRep")?.value ?? false,
    };
    let _enrollmentRentalPropertyLicense: EnrollmentRentalPropertyLicense = {
      regulationLicenseNumber: this.rentalPropertyLicense?.get("departmentOfBusiness")?.value ?? "",
      certificateOfRegistration: this.rentalPropertyLicense?.get("cityOfRegistration")?.value ?? "",
      taxCertificateNumber: this.rentalPropertyLicense?.get("taxCertificateNumber")?.value ?? "",
      stateCertificateHasBeenApplied: this.rentalPropertyLicense?.get("stateCertificateHasBeenApplied")?.value ?? false,
      taxReceipt: this.rentalPropertyLicense?.get("localBusinessTaxReceipt")?.value ?? "",
      reasonWhy: this.rentalPropertyLicense?.get("reasonWhy")?.value ?? "",
    };

    let _enrollmentTaxRepresentative: EnrollmentTaxRepresentative = {
      firstName: this.rentalPropertyReporting?.get("taxRepresentativeFirstName")?.value ?? "",
      lastName: this.rentalPropertyReporting?.get("taxRepresentativeLastName")?.value ?? "",
      email: this.rentalPropertyReporting?.get("taxRepresentativeEmail")?.value ?? "",
      phoneNumber: this.rentalPropertyReporting?.get("taxRepresentativePhoneNumber")?.value ?? "",
      streetAddress: this.rentalPropertyReporting?.get("taxRepresentativeStreetAddress")?.value ?? "",
      aptUnitSuite: this.rentalPropertyReporting?.get("taxRepresentativeAptUnitSuite")?.value ?? "",
      city: this.rentalPropertyReporting?.get("taxRepresentativeCity")?.value ?? "",
      state: Number.parseInt(this.rentalPropertyReporting?.get("taxRepresentativeState")?.value ?? ""),
      zipCode: this.rentalPropertyReporting?.get("taxRepresentativeZipCode")?.value ?? "",
    };
    let modelOwner: OwnerEnrollment = {
      printedName: this.agreements.get("printedName")?.value ?? "",
      firstName: this.ownerForm.get("firstName")?.value ?? "",
      lastName: this.ownerForm.get("lastName")?.value ?? "",
      email: this.ownerForm.get("email")?.value ?? "",
      phoneNumber: this.ownerForm.get("phoneNumber")?.value ?? "",
      streetAddress: this.ownerForm.get("ownerStreetAddress")?.value ?? "",
      aptUnitSuite: this.ownerForm.get("aptUnitSuite")?.value ?? "",
      city: this.ownerForm.get("city")?.value ?? "",
      zipCode: this.ownerForm.get("zipCode")?.value ?? "",
      internationalAddressName: this.ownerForm.get("addressName")?.value ?? "",
      internationalPoboxNumber: this.ownerForm.get("addressOrPoBox")?.value ?? "",
      internationalCityStateProvince: this.ownerForm.get("cityStateProvince")?.value ?? "",
      note: this.ownerForm.get("note")?.value ?? "",
      stateId: Number.parseInt(this.ownerForm.get("state")?.value ?? "0") ?? 0,
      countryId: Number.parseInt(this.ownerForm.get("country")?.value ?? "0"),
      owners: OWNER_DATA,
      companies: COMPANY_DATA,
      enrollmentRentalPropertyLicense: _enrollmentRentalPropertyLicense,
      enrollmentRentalProperty: _enrollmentRentalProperty,
      enrollmentTaxRepresentative: _enrollmentTaxRepresentative,
      isUsingTaxRepresentative: this.rentalPropertyReporting?.get("isUsingTaxRepresentative")?.value ?? false,
    };

    this.enrollment.registerOwner(modelOwner).subscribe({
      next: (response) => {},
      error: (error) => {
        this.showNotification(
          "An error occurred while saving the information. Please try again later.",
          "Indiviual property owner",
          NotificationType.Error
        );
      },
      complete: () => {
        this.stepCompleted = true;
      },
    });
  }
  // Cancel leaves the flow; canDeactivate asks "Leave registration?" when data was entered
  // (a second dialog here made the user confirm twice — QA 2026-10-05).
  openDialog(): void {
    this.returnToStart();
  }
  returnToStart(){
      this.router.navigate(["register/createAccount"]);
  }

  hasUnsavedChanges(): boolean {
    if (this.stepCompleted) {
      return false;
    }
    return [
      this.ownerForm,
      this.rentalPropertyReporting,
      this.propertyBasicInfo,
      this.rentalPropertyLicense,
      this.agreements,
    ].some((form) => form?.dirty);
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (!this.hasUnsavedChanges()) {
      return true;
    }
    const dialogRef = this.dialogRef.open(DialogConfirmComponent, {
      width: "479px",
      data: {
        title: "Leave registration?",
        message:
          "If you leave now you will start over and lose all the information you have entered.",
        confirmButtonText: "LEAVE & LOSE DATA",
        cancelButtonText: "STAY ON PAGE",
      },
    });
    return dialogRef.afterClosed().pipe(map((result) => result === true));
  }

  @HostListener("window:beforeunload", ["$event"])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    if (this.hasUnsavedChanges()) {
      event.preventDefault();
      event.returnValue = "You have unsaved registration data.";
    }
  }
}
